import { Font, StyleSheet } from '@react-pdf/renderer';
import objectSansHeavyFont from '../../img/object-sans-heavy.ttf';

Font.register({ family: 'OpenSans', src: 'https://www.zillowstatic.com/static/fonts/OpenSans-Regular-webfont.ttf' });
Font.register({ family: 'OpenSansBold', src: 'https://www.zillowstatic.com/static/fonts/OpenSans-Bold-webfont.ttf' });
Font.register({
  family: 'VollkornBold',
  src: 'https://www.zillowstatic.com/static-zsg/LATEST/static-zsg/zsg/z-fonts/ivar/IvarHeadline-SemiBold-core.woff',
});
Font.register({
  family: 'ObjectSans',
  src: objectSansHeavyFont,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const disableHyphenationCallback = (word: any) => {
  return [word];
};

Font.registerHyphenationCallback(disableHyphenationCallback);

export const styles = StyleSheet.create({
  // typography
  pageHeading: {
    fontFamily: 'VollkornBold',
    fontSize: 24,
  },
  heading: {
    fontFamily: 'OpenSansBold',
    fontSize: 20,
  },
  subHeading: {
    fontFamily: 'OpenSansBold',
    fontSize: 16,
  },
  bodyHeading: {
    fontSize: 10,
    fontFamily: 'OpenSansBold',
    paddingBottom: 4,
  },
  paragraphSubHeading: {
    fontSize: 10,
    fontFamily: 'OpenSansBold',
    paddingBottom: 4,
    color: '#808080',
  },
  body: {
    fontSize: 16,
    fontFamily: 'OpenSans',
    paddingBottom: 4,
  },
  paragraph: {
    fontSize: 10,
    fontFamily: 'OpenSans',
    paddingBottom: 15,
  },
  bullet: {
    fontSize: 10,
    fontFamily: 'OpenSans',
    marginHorizontal: 3,
  },
  bulletText: {
    fontSize: 10,
    fontFamily: 'OpenSans',
  },
  footerHeading: {
    fontFamily: 'OpenSansBold',
    fontSize: '8px',
  },
  footerText: {
    fontFamily: 'OpenSans',
    fontSize: '8px',
  },
  fineprintHeading: {
    fontFamily: 'OpenSansBold',
    fontSize: '4px',
  },
  fineprintText: {
    fontFamily: 'OpenSans',
    fontSize: '4px',
  },

  // spacing
  marginBottomSm: {
    marginBottom: 16,
  },
  marginAuto: {
    margin: 'auto',
  },
  flexRow: {
    flexDirection: 'row',
  },
  flexColumn: {
    flexDirection: 'column',
  },

  // containers
  page: {
    backgroundColor: '#FFFFFF',
  },
  containerBase: {
    paddingHorizontal: '20px',
    paddingVertical: '10px',
  },
  paymentSummary: {
    width: '100%',
    padding: '20px',
    backgroundColor: '#f9f9fb',
  },
  right: {
    position: 'absolute',
    right: 8,
    top: 8,
  },
  columnStyle: {
    flexDirection: 'column',
    width: '20%',
    fontSize: 8,
  },
  summaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  summaryRowEven: {
    backgroundColor: '#dae1f2',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  rowOdd: {
    backgroundColor: '#f3f7fe',
  },
  rowEven: {
    backgroundColor: 'white',
  },
  rowHighlight: {
    backgroundColor: '#e5f0fb',
  },
  rowTextHighlight: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    backgroundColor: '#e5f0fb',
    color: '#2b6ed9',
  },
  marketPerformanceColumn: {
    width: '12.5%',
    padding: '3px',
    fontSize: '8px',
    border: '1px solid #8ea9db',
  },
  tableColumn: {
    padding: '3px',
    fontSize: '8px',
    border: '1px solid #c4c4c4',
  },
  tableHeader: {
    fontFamily: 'OpenSansBold',
    backgroundColor: '#f1f2f3',
    display: 'flex',
    flexDirection: 'row',
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: '10px',
    border: '1px solid #c4c4c4',
  },
  tableSubHeading: {
    fontFamily: 'OpenSans',
  },
  textAlignRight: {
    textAlign: 'right',
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  textHeadingParagraph: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '8px',
    marginTop: '8px',
  },
});
